import React from "react";

const TurbineOverlay = ({ x, y, mastHeight, bladeScale = 1, reverse = false, testId }) => (
  <g data-testid={testId} transform={`translate(${x} ${y})`}>
    <line stroke="rgba(15,118,110,0.32)" strokeLinecap="round" strokeWidth="5" x1="0" x2="0" y1="8" y2={mastHeight} />
    <circle cx="0" cy="0" fill="rgba(15,118,110,0.72)" r="7" />
    <g>
      <animateTransform
        attributeName="transform"
        attributeType="XML"
        dur={reverse ? "34s" : "28s"}
        from={`0 0 0`}
        repeatCount="indefinite"
        to={`${reverse ? "-360" : "360"} 0 0`}
        type="rotate"
      />
      <path d={`M0 0 C4 ${-20 * bladeScale} 10 ${-62 * bladeScale} 18 ${-104 * bladeScale} L28 ${-96 * bladeScale} C18 ${-60 * bladeScale} 12 ${-18 * bladeScale} 0 0 Z`} fill="rgba(15,118,110,0.44)" />
      <path d={`M0 0 C36 6 70 20 98 42 L92 50 C62 34 34 16 0 6 Z`} fill="rgba(20,184,166,0.38)" />
      <path d={`M0 0 C-20 28 -38 56 -58 88 L-68 80 C-48 52 -26 24 -2 0 Z`} fill="rgba(163,230,53,0.38)" />
    </g>
  </g>
);

export const HeroInfographicOverlay = () => {
  return (
    <svg className="pointer-events-none absolute inset-0 h-full w-full" data-testid="marketing-infographic-overlay" preserveAspectRatio="xMidYMid meet" viewBox="0 0 1600 1400">
      <defs>
        <filter id="hero-soft-glow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur result="blur" stdDeviation="8" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <path d="M200 330C314 314 454 330 610 398C770 468 962 470 1202 382" id="hero-connector-top" />
        <path d="M118 1080C306 1030 448 1008 620 1028C838 1054 1060 1124 1470 1020" id="hero-connector-bottom" />
      </defs>

      <g fill="none" opacity="0.62" strokeLinecap="round" strokeLinejoin="round">
        <path d="M242 188H678" stroke="rgba(15,118,110,0.26)" strokeDasharray="8 10" strokeWidth="3">
          <animate attributeName="stroke-dashoffset" dur="18s" repeatCount="indefinite" values="0;-180" />
        </path>
        <path d="M820 118H1120" stroke="rgba(20,184,166,0.24)" strokeDasharray="8 10" strokeWidth="3">
          <animate attributeName="stroke-dashoffset" dur="20s" repeatCount="indefinite" values="0;-180" />
        </path>
        <path d="M280 1186C424 1146 512 1136 640 1154C826 1180 972 1238 1494 1124" stroke="rgba(255,255,255,0.52)" strokeDasharray="9 12" strokeWidth="4">
          <animate attributeName="stroke-dashoffset" dur="24s" repeatCount="indefinite" values="0;-220" />
        </path>
        <path d="M278 1240C422 1200 532 1190 674 1206C860 1230 1008 1286 1478 1198" stroke="rgba(253,224,71,0.38)" strokeDasharray="7 11" strokeWidth="3">
          <animate attributeName="stroke-dashoffset" dur="22s" repeatCount="indefinite" values="0;-220" />
        </path>
      </g>

      <circle fill="rgba(45,212,191,0.72)" filter="url(#hero-soft-glow)" r="5">
        <animateMotion dur="22s" repeatCount="indefinite" rotate="auto">
          <mpath href="#hero-connector-top" />
        </animateMotion>
      </circle>
      <circle fill="rgba(253,224,71,0.82)" filter="url(#hero-soft-glow)" r="5">
        <animateMotion dur="24s" repeatCount="indefinite" rotate="auto">
          <mpath href="#hero-connector-bottom" />
        </animateMotion>
      </circle>

      {[
        { x: 255, y: 110, w: 18, h: 92, delay: "0s" },
        { x: 280, y: 98, w: 18, h: 104, delay: "1s" },
        { x: 305, y: 92, w: 18, h: 110, delay: "2s" },
        { x: 330, y: 106, w: 18, h: 96, delay: "1.4s" },
        { x: 355, y: 82, w: 18, h: 120, delay: "2.4s" },
        { x: 380, y: 70, w: 18, h: 132, delay: "0.8s" },
        { x: 405, y: 94, w: 18, h: 108, delay: "1.8s" },
        { x: 430, y: 62, w: 18, h: 140, delay: "2.8s" },
        { x: 455, y: 48, w: 18, h: 154, delay: "0.5s" },
        { x: 480, y: 80, w: 18, h: 122, delay: "2.2s" },
        { x: 505, y: 102, w: 18, h: 100, delay: "1.2s" },
        { x: 530, y: 88, w: 18, h: 114, delay: "2.6s" },
      ].map((bar) => (
        <rect fill="rgba(20,184,166,0.18)" key={bar.x} rx="8" width={bar.w} x={bar.x} y={bar.y}>
          <animate attributeName="y" begin={bar.delay} dur="12s" repeatCount="indefinite" values={`${bar.y + 10};${bar.y};${bar.y + 10}`} />
          <animate attributeName="height" begin={bar.delay} dur="12s" repeatCount="indefinite" values={`${bar.h - 10};${bar.h};${bar.h - 10}`} />
        </rect>
      ))}

      {[
        { x: 853, y: 109, w: 92, delay: "0s" },
        { x: 915, y: 135, w: 118, delay: "1.1s" },
        { x: 980, y: 162, w: 124, delay: "2.2s" },
        { x: 1040, y: 190, w: 102, delay: "3s" },
      ].map((bar, index) => (
        <rect fill={index % 2 === 0 ? "rgba(163,230,53,0.22)" : "rgba(34,211,238,0.22)"} height="16" key={bar.x} rx="8" width={bar.w} x={bar.x} y={bar.y}>
          <animate attributeName="width" begin={bar.delay} dur="14s" repeatCount="indefinite" values={`${Math.max(60, bar.w - 14)};${bar.w};${Math.max(60, bar.w - 14)}`} />
        </rect>
      ))}

      {[
        { x: 1332, y: 520, h: 168, delay: "0s" },
        { x: 1380, y: 548, h: 140, delay: "1.2s" },
        { x: 1428, y: 566, h: 122, delay: "2.1s" },
        { x: 1476, y: 604, h: 84, delay: "2.8s" },
        { x: 1524, y: 586, h: 102, delay: "1.7s" },
      ].map((bar) => (
        <rect fill="rgba(15,118,110,0.18)" key={bar.x} rx="9" width="30" x={bar.x} y={bar.y}>
          <animate attributeName="y" begin={bar.delay} dur="13s" repeatCount="indefinite" values={`${bar.y + 8};${bar.y};${bar.y + 8}`} />
          <animate attributeName="height" begin={bar.delay} dur="13s" repeatCount="indefinite" values={`${bar.h - 8};${bar.h};${bar.h - 8}`} />
        </rect>
      ))}

      <g opacity="0.68">
        <circle cx="1188" cy="132" fill="none" r="52" stroke="rgba(20,184,166,0.26)" strokeWidth="10">
          <animate attributeName="stroke-dasharray" dur="12s" repeatCount="indefinite" values="40 320;70 290;40 320" />
        </circle>
        <circle cx="1366" cy="130" fill="none" r="52" stroke="rgba(163,230,53,0.28)" strokeWidth="10">
          <animate attributeName="stroke-dasharray" dur="14s" repeatCount="indefinite" values="60 300;82 278;60 300" />
        </circle>
      </g>

      <TurbineOverlay bladeScale={0.78} mastHeight={255} testId="overlay-turbine-left" x={430} y={350} />
      <TurbineOverlay bladeScale={1.06} mastHeight={360} reverse testId="overlay-turbine-center" x={802} y={246} />
      <TurbineOverlay bladeScale={0.86} mastHeight={266} testId="overlay-turbine-right" x={1238} y={420} />
      <TurbineOverlay bladeScale={0.62} mastHeight={180} reverse testId="overlay-turbine-small" x={1015} y={500} />

      {[{ cx: 378, cy: 860 }, { cx: 642, cy: 860 }, { cx: 836, cy: 860 }, { cx: 960, cy: 860 }, { cx: 1122, cy: 860 }, { cx: 1278, cy: 860 }].map((point, index) => (
        <circle cx={point.cx} cy={point.cy} fill="rgba(15,118,110,0.14)" key={point.cx} r="14" stroke="rgba(255,255,255,0.5)" strokeWidth="1.5">
          <animate attributeName="opacity" begin={`${index * 0.6}s`} dur="9s" repeatCount="indefinite" values="0.38;0.82;0.38" />
          <animate attributeName="r" begin={`${index * 0.6}s`} dur="9s" repeatCount="indefinite" values="12;14;12" />
        </circle>
      ))}

      <g fill="none" opacity="0.7" strokeLinecap="round">
        <path className="hero-overlay-line" d="M70 1184C164 1146 248 1132 338 1148C438 1166 512 1210 598 1228" stroke="rgba(255,255,255,0.55)" strokeWidth="4">
          <animate attributeName="stroke-dasharray" dur="18s" repeatCount="indefinite" values="0 420;260 160;0 420" />
        </path>
        <path d="M590 1186C678 1144 740 1128 840 1138C940 1148 1038 1190 1142 1212" stroke="rgba(253,224,71,0.44)" strokeWidth="3.5">
          <animate attributeName="stroke-dasharray" dur="20s" repeatCount="indefinite" values="0 460;280 180;0 460" />
        </path>
        <path d="M1128 1176C1230 1138 1326 1124 1434 1146C1490 1158 1538 1176 1580 1192" stroke="rgba(45,212,191,0.44)" strokeWidth="3.5">
          <animate attributeName="stroke-dasharray" dur="22s" repeatCount="indefinite" values="0 420;250 170;0 420" />
        </path>
      </g>

      {[{ cx: 86, cy: 1232 }, { cx: 320, cy: 1188 }, { cx: 544, cy: 1242 }, { cx: 880, cy: 1182 }, { cx: 1184, cy: 1224 }, { cx: 1460, cy: 1188 }].map((dot, index) => (
        <circle cx={dot.cx} cy={dot.cy} fill="rgba(255,255,255,0.88)" key={dot.cx} r="4">
          <animate attributeName="opacity" begin={`${index * 0.4}s`} dur="7s" repeatCount="indefinite" values="0.4;0.95;0.4" />
        </circle>
      ))}
    </svg>
  );
};